import { useLiveStreamAppContext } from "../ContextStore/Store";

const ChangeButton = () => {
  const { setIsMic, isLocalVideoStarted, callN } = useLiveStreamAppContext();

  //this is virtual click function which work on the basis of the Data Messaging
  function changeButtonStatus(divElementId, conElementId, message, status) {
    const divElementId2 = document?.getElementById(divElementId);

    if (divElementId2) {
      if (message.includes("DISABLE")) {
        if (!divElementId2.classList.contains("divDisabled")) {
          if (conElementId === "micIcon") {
            if (
              !callN.current?.isMuted &&
              callN.current?.isMuted !== undefined
            ) {
              callN.current?.mute();
              setIsMic(false);
            }
          }
          if (
            isLocalVideoStarted.current === true &&
            conElementId === "camIcon"
          ) {
            if (callN.current?.isLocalVideoStarted) {
              const localVideoStream = callN.current.localVideoStreams.find(
                (stream) => {
                  return stream.mediaStreamType === "Video";
                }
              );
              callN.current?.stopVideo(localVideoStream);
            }
          }
          if (conElementId === "micIcon" && status === "all") {
            let div = document.getElementById("micDropdown");
            div.classList.add("divDisabled");
          }
          if (conElementId === "camIcon" && status === "all") {
            let div = document.getElementById("camDropdown");
            div.classList.add("divDisabled");
          }
          status === "all" && divElementId2.classList.add("divDisabled");
        }
      } else if (message.includes("ENABLE")) {
        if (divElementId2.classList.contains("divDisabled")) {
          divElementId2.classList.remove("divDisabled");
          if (conElementId === "micIcon") {
            let div = document.getElementById("micDropdown");
            div.classList.remove("divDisabled");
          }
          if (conElementId === "camIcon") {
            let div = document.getElementById("camDropdown");
            div.classList.remove("divDisabled");
          }
        }
      }
    } else {
      console.error(
        "Element not found with ID:",
        divElementId,
        conElementId,
        message,
        status
      );
    }
  }
  return { changeButtonStatus };
};

export default ChangeButton;
